import type { CodeString } from '@/consts/codes';
import { z } from 'zod';

const menuItemSchema = z.object({
  Code: z.string().transform((val) => val as CodeString),
  AccessedAt: z.string().optional()
});

export const menuItemsDataSchema = z.object({
  MenuItems: z.array(menuItemSchema)
});

const settingSchema = z.object({
  Id: z.string(),
  Category: z.string(),
  Data: z.string(),
  UserId: z.string(),
  RecordVersion: z.number(),
  OwnerChanged: z.boolean().optional(),
  CompanyId: z.string().nullable().optional(),
  VesselId: z.string().nullable().optional(),
  VesselTypeId: z.string().nullable().optional()
});

const apiResponseSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    Data: dataSchema.nullable().optional(),
    Error: z.boolean().optional(),
    Errors: z.array(z.string()).optional()
  });

export const settingApiResponseSchema = apiResponseSchema(settingSchema);
export const settingsArrayApiResponseSchema = apiResponseSchema(z.array(settingSchema));

export const settingOperationResponseSchema = z.object({
  Data: z
    .object({
      MenuItems: z.array(z.object({ Code: z.string() }))
    })
    .nullable()
    .optional(),
  Error: z.boolean().optional(),
  Errors: z.array(z.string()).optional()
});

export type Setting = z.infer<typeof settingSchema>;
export type MenuItemsData = z.infer<typeof menuItemsDataSchema>;
export interface ApiResponse<T> {
  Data?: T;
  Error?: boolean;
  Errors?: string[];
}
